var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwapHoriz = function SvgSwapHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M17.567 13.143 22 8.57 17.567 4v3.429h-7.79v2.285h7.79zM2 15.429 6.433 20v-3.429h7.79v-2.285h-7.79v-3.429z"
  })));
};
export default SvgSwapHoriz;